import { FC } from 'react';

import { Icon } from '@purpur/library/icon';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { getPurpurIcon } from '@telialt/common-icon/src/utils';
import { NavigationItemDisplayOption } from '@telialt/models/src/Navigation';

import { UserMenuItemType } from '../../model';
import { NAVIGATION_TEST_IDS } from '../../test-ids';
import { MobileMenuItemContainer, StyledMenuLink } from '../MobileMenu/MobileMenu.styles';
import { ListItem, MenuListItemLink, StyledMobileMenuItemContent } from './MenuItemUser.styles';

type Props = {
    menuItem: UserMenuItemType;
    displayOption?: NavigationItemDisplayOption;
};

export const UserMenuListItem: FC<Props> = ({ menuItem, displayOption }) => {
    const { t } = useTranslations();
    const { id, icon, url, openInNewTab, isActive } = menuItem;

    const itemContent = (
        <>
            <Icon svg={getPurpurIcon(icon)} size={displayOption === 'Mobile only' ? 'md' : 'xs'} />
            {t[`navbar.account.user_menu.${id}.link`]}
        </>
    );

    if (displayOption === 'Mobile only') {
        return (
            <MobileMenuItemContainer data-test={NAVIGATION_TEST_IDS.MOBILE_MENU_ITEM}>
                <StyledMenuLink
                    href={url}
                    target={openInNewTab ? '_blank' : undefined}
                    $isActive={isActive}
                    role="menuitem"
                >
                    <StyledMobileMenuItemContent>{itemContent}</StyledMobileMenuItemContent>
                </StyledMenuLink>
            </MobileMenuItemContainer>
        );
    }

    return (
        <ListItem data-test={NAVIGATION_TEST_IDS.USER_MENU_ITEM} role="menuitem">
            <MenuListItemLink variant="standalone" href={url} target={openInNewTab ? '_blank' : undefined}>
                {itemContent}
            </MenuListItemLink>
        </ListItem>
    );
};
